<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import MyGamesModal from './MyGamesModal.vue';

const emit = defineEmits(['toggle-sidebar']);
const router = useRouter();
const showMyGames = ref(false);

const toggleSidebar = () => {
  emit('toggle-sidebar');
};

defineProps({
  collapsed: {
    type: Boolean,
    required: true
  }
});

const goToLogin = () => {
  router.push('/login');
};

const openMyGames = () => {
  showMyGames.value = true;
};

const closeMyGames = () => {
  showMyGames.value = false;
};
</script>

<template>
  <nav class="navbar navbar-dark fixed-top">
    <div class="container-fluid d-flex align-items-center">
      <div class="d-flex align-items-center">
        <button class="btn btn-link sidebar-toggle me-2" @click="toggleSidebar">
          <i class="bi bi-list fs-4"></i>
        </button>

        <router-link class="navbar-brand d-flex align-items-center" to="/">
          <div class="logo-container" style="width: 60px; height: 60px;">
            <img src="../assets/Yalaagames.png" alt="YalaaGame" class="logo-image" crossorigin="anonymous"
              style="width: 70px; height: 70px;">
          </div>
          <span class="fw-bold" style="color: #F09F27;">yalaa<span class="text-white">game</span></span>
        </router-link>
      </div>

      <div class="nav-search-container flex-grow-1 mx-4 position-relative d-none d-md-block">
        <i class="bi bi-search search-icon"></i>
        <input type="text" class="form-control search-bar" placeholder="Search">
      </div>

      <div class="nav-actions d-flex align-items-center">
        <button class="btn btn-icon me-2">
          <i class="bi bi-person-circle fs-4"></i>
        </button>
        <button class="btn btn-icon me-2" @click="openMyGames">
          <i class="bi bi-heart fs-4"></i>
        </button>
        <button class="btn btn-login" @click="goToLogin" style="padding: 0.375rem 1rem;font-size: 0.875rem;background-color: #7e3af2;color: #fff;font-weight: 500;border-radius: 50px;">
          Log in
        </button>
      </div>
    </div>
  </nav>

  <MyGamesModal v-if="showMyGames" @close="closeMyGames" />
</template>

<style scoped>
.navbar {
  background-color: #1a1b26;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  height: 90px;
}

.navbar-brand {
  color: #7e3af2;
  font-weight: 700;
  font-size: 1.5rem;
}

.sidebar-toggle {
  color: white;
  padding: 0;
  min-width: 32px;
}

.btn-icon {
  background: transparent;
  color: #e5e7eb;
  border: none;
  padding: 0.5rem;
}

.btn-icon:hover {
  color: #7e3af2;
}

.logo-container {
  width: 60px;
  height: 60px;
}

.logo-image {
  width: 56px;
  height: 56px;
}

@media (max-width: 768px) {
  .navbar {
    height: 80px;
    padding: 0.5rem 1rem;
  }

  .nav-search-container {
    display: none;
  }

  .navbar-brand {
    font-size: 1.25rem;
  }

  .logo-container {
    width: 48px;
    height: 48px;
  }

  .logo-image {
    width: 44px;
    height: 44px;
  }

  .btn-login {
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
    background-color: #7e3af2 !important;
    color: #fff;
    font-weight: 500;
    border-radius: 50px;
  }
}

@media (max-width: 576px) {
  .navbar-brand span {
    display: none;
  }

  .logo-container {
    width: 40px;
    height: 40px;
    margin-right: 0 !important;
  }

  .logo-image {
    width: 36px;
    height: 36px;
  }
}
</style>